import { Box } from '@wix/design-system';
import classNames from 'classnames';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { BACKGROUND_DARK_COLOR } from '../../../../constants';
import { selectIsConnectingAgent, selectIsLiveChat } from '../../../common/selectors/chat';
import { selectOnlineAgent } from '../../../common/selectors/header';
import { FloatingBannerOrigin } from '../../../components/FloatingBanner/FloatingBanner';
import { StatusBanner } from '../../../components/StatusBanner';
import { renderModel } from '../../../util/renderModel';
import { AnnouncementBanner } from './AnnouncementBanner';
import { CopilotRedesignTitle } from './CopilotRedesignTitle';
import { FullPageTitle } from './FullPageTitle';
import { headerFullPageDataHooks } from './HeaderFullPage.dataHooks';
import { HeaderFullPageActions } from './HeaderFullPageActions';
import style from './styles.scss';

const isCopilot = renderModel.isCopilot();

export const HeaderFullPage: FC = () => {
  const isLiveChat = useSelector(selectIsLiveChat);
  const agent = useSelector(selectOnlineAgent);
  const isConnectingAgent = useSelector(selectIsConnectingAgent);

  if (isCopilot) {
    const headerClassName = classNames(style.copilotAppHeader, style.copilotAppHeaderRedesign);

    return (
      <>
        <Box className={headerClassName} align="space-between">
          <CopilotRedesignTitle isLiveChat={isLiveChat} agent={agent} />
          <HeaderFullPageActions />
        </Box>
        <AnnouncementBanner dataHook={headerFullPageDataHooks.announcementBanner()} />
        <StatusBanner />
      </>
    );
  }

  return (
    <>
      <Box
        className={style.contactAppHeader}
        align="space-between"
        verticalAlign="middle"
        backgroundColor={BACKGROUND_DARK_COLOR}
      >
        <FullPageTitle isLiveChat={isLiveChat} isConnectingAgent={isConnectingAgent} agent={agent} />
        <HeaderFullPageActions />
      </Box>
      <AnnouncementBanner dataHook={headerFullPageDataHooks.announcementBanner()} />
      <StatusBanner origin={FloatingBannerOrigin.FullPage} />
    </>
  );
};
